import React from 'react'
import { shallow } from 'enzyme'
import TableWrapper from '../../components/TableWrapper'

describe('TableWrapper', () => {
  let wrapper, props, instance

  beforeAll( () => {
    props = {
      customHeaders: null
    }
    wrapper = shallow(<TableWrapper {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe('#renderHeaders', () => {
    it('should return obj', () => {
      const { renderHeaders } = instance

      expect(renderHeaders()).toBeTruthy()
    })
  })

  describe('#headers', () => {
    it('should return obj', () => {
      const { headers } = instance

      expect(headers.length).toBe(2)
    })
  })
})